import React, { useState } from "react";
import { Button, Icon, Checkbox, Select } from "semantic-ui-react";
import { SortableHandle } from "react-sortable-hoc";
import { DragDropTableRowStyles as st } from "./styles";

const RowHandler = SortableHandle(() => <Icon name="arrows alternate vertical" style={{ cursor: "grab" }} />);

export const DragDropTableRow = ({
	index,
	analyse,
	lang,
	analysesFactory,
	removeAnalysisFromSet,
	addAnalysisToSet,
	isSecretary,
	isMobile,
	saveMotivation,
	checkAnalysis,
}) => {
	const [motivations, setMotivations] = useState(
		analyse.question_answers && analyse.question_answers.length > 0
			? analyse.question_answers
					.filter((qa) => qa.codes && qa.codes.length > 0)
					.map((qa) => {
						return { qa: qa.id, code: qa.codes[0] };
					})
			: []
	);
	const [checked, setChecked] = useState(!!analyse.checked_by);

	const getTranslatedLabel = () => {
		switch (lang) {
			case "en": {
				return analyse.properties?.label_en || analyse.label;
			}
			case "de": {
				return analyse.properties?.label_de || analyse.label;
			}
			case "fr": {
				return analyse.properties?.label || analyse.label;
			}
			default: {
				return analyse.properties?.label || analyse.label;
			}
		}
	};
	/* 	const sortMotivations = (a, b) => {
		if (a.code_agency === "999" && b.code_agency !== "999") return 1;
		if (a.code_agency !== "999" && b.code_agency === "999") return -1;
		if (a.code_agency === "10" && b.code_agency !== "10") return 1;
		if (a.code_agency !== "10" && b.code_agency === "10") return -1;
		if (a.code_agency !== "999" && a.code_agency !== "10" && b.code_agency !== "999" && b.code_agency !== "10") return a.id - b.id;
	}; */

	return (
		<>
			<div
				style={{
					...st.completeRaw,
					backgroundColor:
						analysesFactory.remove.findIndex((elt) => elt.id === analyse.id) > -1
							? "rgba(169, 0, 10, 0.1)"
							: analysesFactory.add.findIndex((elt) => elt.id === analyse.id) > -1
							? "rgba(74, 134, 82, 0.1)"
							: "whitesmoke",
				}}
			>
				<div style={st.raw}>
					<div style={isMobile ? st.codeMobile : st.code}>
						<RowHandler />{" "}
						{isSecretary && (
							<Checkbox
								label={analyse.code ?? analyse.properties.code}
								style={{
									...st.checkbox,
									textDecoration: analysesFactory.remove.findIndex((elt) => elt.id === analyse.id) > -1 ? "line-through" : "none",
								}}
							/>
						)}
						{!isSecretary && (
							<>
								{analysesFactory.add.findIndex((elt) => elt.id === analyse.id) === -1 &&
									analysesFactory.remove.findIndex((elt) => elt.id === analyse.id) === -1 && (
										<Checkbox
											checked={!!checked}
											style={{ paddingTop: "5px", marginRight: "5px", fontSize: "0.9rem" }}
											onClick={async (e, data) => {
												if (e !== undefined) e.preventDefault();
												if (checkAnalysis) checkAnalysis(analyse.id, data.checked);
												setChecked(data.checked);
											}}
										/>
									)}
								<span
									style={{
										textDecoration: analysesFactory.remove.findIndex((elt) => elt.id === analyse.id) > -1 ? "line-through" : "none",
									}}
								>
									{analyse.code ?? analyse.properties.code}
								</span>
							</>
						)}
					</div>
					<div style={isMobile ? st.spaceMobile : st.space}>
						{analysesFactory.remove.findIndex((elt) => elt.id === analyse.id) > -1 ? (
							<Button onClick={() => addAnalysisToSet(analyse)} size="mini" icon="undo" style={st.addAnalysis} circular></Button>
						) : (
							<Button onClick={() => removeAnalysisFromSet(analyse)} size="mini" icon="close" style={st.removeAnalysis}></Button>
						)}
					</div>
					<div style={{ ...st.label }}>
						<span style={{ textDecoration: analysesFactory.remove.findIndex((elt) => elt.id === analyse.id) > -1 ? "line-through" : "none" }}>
							{getTranslatedLabel()}
						</span>
						<span>{analysesFactory.remove.findIndex((elt) => elt.id === analyse.id) > -1 ? <span style={st.deleted}>Supprimé</span> : ""}</span>
						<span>{analysesFactory.add.findIndex((elt) => elt.id === analyse.id) > -1 ? <span style={st.new}>Nouveau</span> : ""}</span>
					</div>
				</div>
				{/* //analyse ajoutée avant sauvegarde */}
				{!analyse.question_answers &&
					analyse.questions &&
					analyse.questions.length > 0 &&
					analyse.questions.some((q) => q.question?.motivation) &&
					analyse.questions
						.filter((q) => q.question && q.question.motivation && q.question.sil_code !== "MARQTUM-M01" && q.question.code !== "MOT-PREGSERO")
						.map((quest) => (
							<div style={st.motivationRaw} key={`quest-${quest.id}`}>
								<Icon name="share" flipped="vertically" /> <span style={{ color: "#c77777" }}> Motivation :</span>{" "}
								<Select
									style={{ minWidth: "calc(100% - 140px)" }}
									placeholder="Motif"
									options={quest.question.answer_options.map((ao) => {
										return { key: ao.answer_option.code, value: ao.answer_option.code, text: ao.answer_option.label };
									})}
									value={motivations.some((m) => m.qa === quest.id) ? motivations.filter((m) => m.qa === quest.id)[0].code : ""}
									onChange={(e, { value }) => {
										let motives = motivations.slice();
										if (motives.some((m) => m.qa === quest.id)) motives.filter((m) => m.qa === quest.id)[0].code = value;
										else motives = motives.concat({ qa: quest.id, code: value });
										saveMotivation(null, value, analyse.id);
										setMotivations(motives);
									}}
								/>
							</div>
						))}

				{/* //analyse déjà connue  */}
				{analyse.question_answers &&
					analyse.question_answers.length > 0 &&
					analyse.question_answers.some(
						(qa) =>
							qa.question &&
							qa.question.motivation &&
							qa.question.sil_code !== "MARQTUM-M01" &&
							qa.question.code !== "MOT-PREGSERO" &&
							qa.question.answer_options
					) &&
					analyse.question_answers
						.filter((qa) => qa.question && qa.question.motivation && qa.question.answer_options && qa.question.answer_options.length > 0)
						.map((qa) => (
							<div style={st.motivationRaw} key={`qa-${qa.id}`}>
								<Icon name="share" flipped="vertically" /> <span style={{ color: "#c77777" }}> {qa.question.label}</span>{" "}
								<Select
									style={{ minWidth: "calc(100% - 140px)" }}
									placeholder="Motif"
									options={qa.question.answer_options.map((ao) => {
										return { key: ao.answer_option.code, value: ao.answer_option.code, text: ao.answer_option.label };
									})}
									value={motivations.some((m) => m.qa === qa.id) ? motivations.filter((m) => m.qa === qa.id)[0].code : ""}
									onChange={(e, { value }) => {
										let motives = motivations.slice();
										if (motives.some((m) => m.qa === qa.id)) motives.filter((m) => m.qa === qa.id)[0].code = value;
										else motives = motives.concat({ qa: qa.id, code: value });
										saveMotivation(qa.id, value);
										setMotivations(motives);
									}}
								/>
							</div>
						))}
			</div>
		</>
	);
};
